import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import TransitionText from '../common/TransitionText';
import SecondaryCopy from './SecondaryCopy';
import SecondaryHeadline from './SecondaryHeadline';
import Gallery from '../common/Gallery';
import { ReactComponent as ArrowLeftIcon } from '../../assets/icons/ArrowLeftIcon.svg';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/ArrowRightIcon.svg';

const useStyles = createUseStyles(
    {
        wrap: {
            height: '100%',
            display: 'flex',
        },

        frame: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            paddingBottom: 100,
            width: '100%',
        },

        image: {
            display: 'block',
            marginBottom: 15,
            maxWidth: '100%',
        },

        titleLine: {
            display: 'flex',
            flexDirection: 'column-reverse',

            '@media (min-width: 1024px)': {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            },
        },

        arrows: {
            margin: '0 auto 48px',
            alignSelf: 'center',
            display: 'flex',
            alignItems: 'center',

            '@media (min-width: 1024px)': {
                marginBottom: 15,
            },
        },

        arrowBtn: {
            height: 17,

            '@media (min-width: 1024px)': {
                height: 23,
            },
        },

        btnLeft: {
            marginRight: 16,
        },

        btnRight: {
            marginLeft: 16,
        },

        count: {
            whiteSpace: 'nowrap',
            position: 'relative',
            top: -3,
        },
    },
    { name: 'SecondaryGallery' }
);

export default function SecondaryGallery({ hotspot, state }) {
    const classes = useStyles();
    const images = hotspot.content.images;

    const [active, setActive] = useState(0);

    const goPrev = () => {
        setActive((val) => (val + images.length - 1) % images.length);
    };

    const goNext = () => {
        setActive((val) => (val + 1) % images.length);
    };

    return (
        <div className={classes.wrap}>
            <div className={classes.frame}>
                <Gallery active={active} images={images} />
                <div className={classes.titleLine}>
                    <SecondaryHeadline
                        title={hotspot.content.title}
                    ></SecondaryHeadline>
                    <div className={classes.arrows}>
                        <button className={classes.btnLeft} onClick={goPrev}>
                            <ArrowLeftIcon
                                width="100%"
                                height="100%"
                                className={classes.arrowBtn}
                            />
                        </button>
                        <span className={classes.count}>
                            {active + 1} / {images.length}
                        </span>
                        <button className={classes.btnRight} onClick={goNext}>
                            <ArrowRightIcon
                                width="100%"
                                height="100%"
                                className={classes.arrowBtn}
                            />
                        </button>
                    </div>
                </div>
                <SecondaryCopy>{hotspot.content.copy}</SecondaryCopy>
            </div>
        </div>
    );
}
